import React from 'react';
import styles from './Card.module.scss';

const Card = ({ card }) => {
  const style = card.special || `${card.pal}-${card.num}`;
  return <div className={`${styles.card} ${styles[style]}`} />;
};

export default Card;
